import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, retry, delay} from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import {  FilterSettingsModel, IFilter, IFilterUI } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { DataManager } from '@syncfusion/ej2-data';
import { MyobServiceInvoice } from './../../../models/myob-service-invoice.model';
import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';

@Component({
  selector: 'app-myob-api-invoice-sync-tools-widget',
  templateUrl: './myob-api-invoice-sync-tools-widget.component.html',
  styleUrls: ['./myob-api-invoice-sync-tools-widget.component.css']
})
export class MyobApiInvoiceSyncToolsWidgetComponent implements OnInit {


     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() invoice_id?: Observable<any[]>; // impliments on changes.
     @Input() UID?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  
     job: Object;
     job_id;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;



// Grid Vars
public data: DataManager;
public data_subjects: DataManager;
public pageSettings: Object;
public pageOptions = { pageSize: 100 }; 
public filterOptions: FilterSettingsModel;
public formatOptions: Object;
// public filterOptions: FilterSettingsModel;
public filter : IFilter;
public toolbarOptions: ToolbarItems[];
@ViewChild('grid')
public grid: GridComponent;
public groupOptions: GroupSettingsModel;
public templateOptionsDate: IFilterUI;
public elem1: HTMLElement;
public datePickerObj: DatePicker;
subjects_urgent: any;
formatoptions: { type: string; format: string; };
dateFormat: string;
sortOptions: { columns: { field: string; direction: string; }[]; };

today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
// today_set = new Date(); // sets todays date
// today = this.datepipe.transform(this.today_set, 'dd/MM/yyyy h:mm a'); // formats date for comparison

initialPage: { pageSize: number; };
 invoices: any;
 modalRef: any;
 myobInvoiceCreatedData: any;
 myobInvoiceListMapped: any;
 set_RowVersion: any;
 brand: any;
 brandData: any;
 data_invoice: any = MyobServiceInvoice;
 myobInvoices: Object;
 arrCase: object[];
 Items: any;
 myobInvoiceDeleteData: Object;
 myobInvoice: Object;
 invoiceItem: any;
 invoiceItemsList: any = SubjectInvoiceItem;
 
 myob_account_codes: Object;
 myob_tax_codes: Object;
 myobInvoiceUpdateData: any;
 myobInvoiceUpdatedData: any;

 invoice_model: SubjectInvoice = new SubjectInvoice();
 invoice_item_model: any = SubjectInvoiceItem;
 invoiceItemUpdateList: any;
 new_line: {};
  subject: Object;
  subject_number: any;
  brand_invoice_id: any;
  invoice_job_type_id: any;
  invoice_brand: Object;
  owner_brand: Object;
  invoice_status: Object;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: Object;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: Object;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  invoice_status_all: Object;
  invoice_payment_status_all: Object;
  invoice_communication_status_all: Object;
  subject_id: any;
  invoice_number: any;
  is_job_invoice_var: any;
  brand_data: Object;
  myob_checker: Object;
  myob_response;



    // sees if there is a change in myCount
    @Output() change: EventEmitter<any> = new EventEmitter<any>();
// New event emitter to show the results of api calls to other modules from this component as sendResponse() results.. set response_from_node
  @Output('sendResponse') sendResponse: EventEmitter<any> = new EventEmitter();
  @Output() test_message: EventEmitter<any> = new EventEmitter<any>();


  response_from_node: any;
  response_from_node_raw: any;
  error_message: any;
  error_message_standard: any;
  error_name: any;
  full_response_data: any;
  data_sent: any;
  data_sent_id: any;
  owner_trace_code: any;
  // test_message:any;


  
    constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
      private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService,
      //  vcr: ViewContainerRef,
    ) {


      // this.toastr.setRootViewContainerRef(vcr);

 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

      // Grid Options
      this.toolbarOptions = ['Search'];
      this.initialPage = { pageSize: 40 };
      this.filterOptions = {
        type: 'Menu'
      };
      // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
      this.groupOptions = { }; // sets auto grouping for the grid
      this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
      this.dateFormat = 'dd/MM/yyyy hh:mm a';
      //this.filter = { params: { format: this.dateFormat } };
      this.sortOptions = { columns: [{ field: 'invoice_number', direction: 'Descending' } ] };
      
      // 2023 I removed these to try and increase the speed of the invoice page.
              // this.myob_response = true;
              // this.myobChecker();
              this.gfunc.myobChecker();

     }
  
     // check for changes. to load data.
     ngOnChanges(changes) {



      if (changes.item_id) {
        // deal with asynchronous Observable result
        this.invoice_id = changes.item_id.currentValue;
        this.UID = changes.UID.currentValue;
        // this.getJob(this.job_id);
      }


      if (changes.invoice_id) {

        // this.test_message = 'We have recieved this message to the parent from the child component.';
        // this.SendResponse.emit("Sending a Test SendResponse.");

        this.invoice_id = changes.invoice_id.currentValue;
    
        this.getJobSubject(this.subject_id);
        // this.getJob(this.job_id); // I Load this in the subject above
        this.getInvoiceStatusAll();
        this.getInvoicePaymentStatusAll();
        this.getInvoiceCommunicationStatusAll();
    
        this.getInvoice(this.invoice_id);
        // this.getInvoiceItmes(this.invoice_id);
       // this.doCalculations(); // may need to adjust to update pricing details??

       // load some myob stuff
       this.getMyobTaxCodes(); // load for merge variables arrays
       this.getMyobAccountCodes();
      }



    }


    
  
  
    ngOnInit() {
      // this.test_message = 'We have recieved this message to the parent from the child component.';
        // this.sendResponse.emit("Sending a Test SendResponse.");

    }
  
    // Functions
  // getJob(job_id) {
  //   this._demoService.getJobID(job_id).subscribe(
  //      data => { this.job = data;
  //       let res = data[0];
  //       // Run the job data queries.
  //     },
  //      err => console.error(err),
  //      // () => console.log('done loading Trace Types')
  //    );
  //  }




 
  getInvoice(invoice_id){
    this._demoService.getSubjectInvoice(invoice_id).subscribe(
      (data) => {
        this.invoiceItem = data;
        let res = data[0];
        this.invoice_number = res.invoice_number;
        this.is_job_invoice_var = res.is_job_invoice;
        this.invoice_model.is_job_invoice = res.is_job_invoice;
        // Set status based in ID - For template interactions // RULES
        // this.invoice_status_text = 'PAID';
        // this.getInvoiceStatus(res.invoice_status_id);
        // this.getInvoicePaymentStatus(res.invoice_payment_status_id);
        // this.getInvoiceCommunicationStatus(res.invoice_communication_status_id);

        this.invoice_model = this.invoiceItem;
        // this.doCalculations();
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    ) };


     
   getInvoiceItmes(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];


        this.invoice_item_model = this.invoiceItemsList;
        // this.doCalculations();
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    ) };
 


    
    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
         // this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");

         this.job_id = res.job_id;
         this.getJob(this.job_id);
         

        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }
 


  getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.job = data;
      let res = data[0];
      // Run the job data queries.
    this.brand_invoice_id =  res.brand_invoice_id;
    this.invoice_job_type_id = res.job_type_id;
    this.getInvoiceBrand(res.brand_invoice_id);
    this.getOwnerBrand(94);
    this.owner_trace_code = res.owner_trace_code;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 private getInvoiceBrand(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.invoice_brand = data;
      let res = data[0];
    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}


private getOwnerBrand(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    (data) => {
      this.owner_brand = data;
      let res = data[0];
    },
    (err) => console.error(err),
    () => console.log('Brand Loaded.')
  );
}



getInvoiceStatus(invoice_status_id){
  this._demoService.getInvoiceStatus(invoice_status_id).subscribe(
    (data) => {
      this.invoice_status = data;
      let res = data[0];
      this.invoice_status_name = res.invoice_status_name;
      this.invoice_status_var = invoice_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



getInvoicePaymentStatus(invoice_payment_status_id){
  this._demoService.getInvoicePaymentStatus(invoice_payment_status_id).subscribe(
    (data) => {
      this.invoice_payment_status = data;
      let res = data[0];
      this.invoice_payment_status_name = res.invoice_payment_status_name;
      this.invoice_payment_status_var = invoice_payment_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatus(invoice_communication_status_id){
  this._demoService.getInvoiceCommunicationStatus(invoice_communication_status_id).subscribe(
    (data) => {
      this.invoice_communication_status = data;
      let res = data[0];
      this.invoice_communication_status_name = res.invoice_communication_status_name;
      this.invoice_communication_status_var = invoice_communication_status_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}





getInvoiceStatusAll(){
  this._demoService.getInvoiceStatusAll().subscribe(
    (data) => {
      this.invoice_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

getInvoicePaymentStatusAll(){
  this._demoService.getInvoicePaymentStatusAll().subscribe(
    (data) => {
      this.invoice_payment_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatusAll(){
  this._demoService.getInvoiceCommunicationStatusAll().subscribe(
    (data) => {
      this.invoice_communication_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}






/* BOF Myob Functions */



setMyobInvoiceModelStep1(model){

     // 7/02/24 Added to do a Myob Check First Prior to Making a move. // THIS WORKED LIKE A TREAT.
     this.gfunc.myobChecker();

// Load the tax code here and see if works to make them avaiable to an external module fom this component,
  this.getMyobTaxCodes(); // load this onInit.
  this.getMyobAccountCodes();

  // this.invoice_item_model = null;
  this.getInvoiceItmesStep(model.invoice_id, model);
        // (async () => {
  
        //   await this.delay(8000);
        //  })(); // end async function
  
    };
  
// Get Invoice Items
getInvoiceItmesStep(invoice_id, model){
  this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
    (data) => {
      this.invoiceItemsList = data;
      let res = data[0];
      this.invoice_item_model = this.invoiceItemsList;
      this.setMyobInvoiceModelStep2(model); // ru
     
      // this.doCalculations();
    },
    (err) => {
    //   this.sendResponse.emit(err);
    //  this.response_from_node = err;
    //   console.error(err);
    //   this.toastr.error('Error Updating Invoice to Myob Details' + err.error_message_standard);
    //   this.response_from_node = err.full_response_data;
    //   this.sendResponse.emit(err);
    //   this.sendResponse.emit(err.full_response_data);
    //   this.test_message = err.full_response_data;
    //   console.log('FullRespoonse Error Inside Tools 3: ' + err.full_response_data)
    //   return(this.response_from_node = err);



           // Need to set some error varibles
           this.error_message = err.error.error_message;
           this.error_message_standard = err.error.error_message_standard;
           this.error_name = err.error.error_name;
           this.full_response_data = err.error.full_response_data;
           this.data_sent = err.error.data_sent;
           this.data_sent_id = err.error.data_sent_invoice_id;
 
          
 
           this.response_from_node = JSON.stringify(err)
           this.response_from_node_raw = err;
           this.sendResponse.emit(this.response_from_node);
           console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
           this.test_message = this.response_from_node; // could be as simple as this?
           return(this.response_from_node = JSON.stringify(err)); // do this so other componets get


      // return err.res.status(201).json({ success: " Supplier Agent RE-Connect Complete " });
    },
   () => console.log('Invoice Items Loaded.')
  )};

  // :: Create Invoice.
  // Run this to Create An Invoice as first Step of Process of Functions
setMyobInvoiceModelStep2(model){
       // Lookup invoice items with delay
       
        // (async () => {
      // Need to lookup/brand customer details as well.
  
  
  
    //   var promise = new Promise<void>((resolve, reject) => {
    //     setTimeout(() => {
    //       this.getInvoiceItmes(model.invoice_id);
    //       console.log("Async Work Complete");
    //       resolve();
    //     }, 1000);
    //   });
    // promise;
    
    this.data_invoice = {}; // make sure its clean in case we loop from other module. 

// need to get new  "po_number": "90000117", and set job - owner trace code

        // this.getJob(model.job_id); // looks up PO number owner_trace_code = cleint refreence.


  
      this._demoService.getBrandById(model.to_brand_id).subscribe(
        data => { this.brand = data;
        const  res = data[0];
                          this.brandData = res;
                    console.log('Brand MyobID: ' + res.myob_id);
                    console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                    console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                    // Invoice Model.- use return so that model is available in the outside subscription
                   
  // Meed to get a model of the Tax Code ID
  // Memo if a subject or job invoice
  let JournalMemo;
  if (model.is_job_invoice >= 1) {
    JournalMemo = 'Job Invoice';
  }else{
    JournalMemo = 'Subject Invoice';
  };
  
  let BillDeliveryStatus;
  if (model.invoice_communication_status_id === 1) { // email
    BillDeliveryStatus = 'Nothing';
  }else{
    BillDeliveryStatus = 'Print';
  }

// Due Date Function June 2025 to remove time zones from date.
       let myob_format_date_created = this.gfunc.parseMyobDate(model.date_created)
       let myob_format_date_due = this.gfunc.parseMyobDate(model.due_date)
  
                    this.data_invoice = {
                    'Number': model.invoice_number, //  model.invoice_number
                     // 'Date': model.date_created,
 'Date': myob_format_date_created,
                    'SupplierInvoiceNumber': model.SupplierInvoiceNumber,
                    'Customer': {
                    'UID': this.brandData.myob_id
                    },
                    'ShipToAddress': '' ,
                    'Terms': {
                    'PaymentIsDue': 'DayOfMonthAfterEOM',
                    'DiscountDate': 1,
                    'BalanceDueDate': 30,
                    'DiscountForEarlyPayment': 0,
                    'MonthlyChargeForLatePayment': 0,
                    'DiscountExpiryDate': model.due_date,
                    'Discount': 0,
                    'DueDate': model.due_date
                    },
                    'IsTaxInclusive': true,
                    'IsReportable': true,
  
                    'Lines': [
                    // {
                    // 'Type': '',
                    // 'Description': '' ,
                    // 'Account': {
                    // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                    // },
                    // 'Total': 6,
                    // 'Job': null,
                    // 'TaxCode': {
                    // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                    // }
                    // },
                    ],
  
                    'Subtotal': model.invoice_subtotal,
                    'Freight': 0,
                    'FreightTaxCode': {
                    'UID': this.gfunc.myob_FreightTaxCode
                    },
                    'TotalTax': model.invoice_gst,
                    'TotalAmount': model.invoice_total,
                    'Category': null,
                    'Comment': '',
                    'ShippingMethod': null,
                    'PromisedDate': null,
                    'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.invoice_number,
                    'BillDeliveryStatus': BillDeliveryStatus,
                    'AppliedToDate': 0,
                    'BalanceDueAmount': model.invoice_remaining_total,
                    'Status': 'Open',
                    'LastPaymentDate': null,
                    'Order': null,
                    'ForeignCurrency': null,
                    'CustomerPurchaseOrderNumber':  model.po_number,
                    'po_number':  model.po_number,
                    };
  
  
  
                        // :: This function Collects and pushes the lines to the rows of the invoice.
                    // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                    // need to loop through the invoice model and create Lines.
  
  
  
                    let newArr = Object(this.invoice_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
  
                    let  count_of_items = Object.keys(newArr).length;
                    //  let res = data[0];
                    // Run the job data queries.
                    // need to do a loop of subject_billing items (.length)
                    for(let i=0;i < count_of_items; i++) {
                      let res = newArr[i];
  
  
      // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!

      // 2023 Feb update because tax codes should already be set. - as part of the billing items upgrades.

                        // Activated so that The tax code are available from other components running this from outside this module
                        // this.getMyobTaxCodes(); // load this onInit.
                        // this.getMyobAccountCodes();


                       const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc)=>(mtc.myob_tax_code_id === res.myob_tax_code_id ));
                       const retAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === res.myob_account_code_id ));
                      // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
                      // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));

                      // Update to warn why invoice not syncing if tax code and account code are incorrect. feb 2023
                      if(!retTaxCodeUID[0]){this.toastr.error('TaxCodes Do Not Match items with Account Settings. Please Match your Billing Items with Myob Tax and Account Codes and update this invoice to continue. Delete Items and Billing Tasks before trying to push this invoice again.'); return;}

                      if(!retAccountUID[0]){this.toastr.error('Account Codes Do Not Match items with Account Settings. Please Match your Billing Items with Myob Tax and Account Codes and update this invoice to continue. Delete Items and Billing Tasks before trying to push this invoice again.'); return;}

                      let TaxAccountUID = retTaxCodeUID[0].UID;
                      let MyobAccountUID = retAccountUID[0].UID;

                      console.log('Tax Code: ' + retTaxCodeUID[0].UID);
                      console.log('Acc Code: ' + retAccountUID[0].UID);
  
  
                      let new_line = {
                        // 'RowID': res.invoice_item_id, // see if this works then I can  upate easier. /// no this failed.
                        'Type': 'Transaction',
                        'Description': res.billing_task_name,
                        'Account': {
                        'UID': MyobAccountUID,
                        // 'UID': res.myob_account_code_id,
                        },
                        'Total': res.total,
                        'Job': null,
                        'TaxCode': {
                        'UID': TaxAccountUID
                        // 'UID': res.myob_tax_code_id,
                        }
                        };
  
                    this.data_invoice.Lines.push(new_line);
                    }
  
                    console.log('New Pushed Model: ' + JSON.stringify(this.data_invoice));
                   // Must be here do not move.
                    console.log('invoice model Loaded.');
                    this.createMyobInvoiceModel(model, this.data_invoice);
  
        },
        // err => {
        //   // this sets the response_from_node varianle and function in scripts using this module
        // //   this.SendResponse.emit(err);
        // //  this.response_from_node = err

        //  this.toastr.error('Error Updating Invoice to Myob Details' + err.error_message_standard);
        //  this.response_from_node = err.full_response_data;
        //  // this.SendResponse.emit(error);
        //  // this.SendResponse.emit(error.full_response_data);
        //  console.log('FullRespoonse Error Inside Tools 2: ' + err.full_response_data)
        //  return(this.response_from_node = err);

        //   // console.error(err)
        //   // return err.res.status(201).json({ success: " Sync Complete " });
        // },


        (err) => {
          //   this.sendResponse.emit(err);
          //  this.response_from_node = err;
          //   console.error(err);
          //   this.toastr.error('Error Updating Invoice to Myob Details' + err.error_message_standard);
          //   this.response_from_node = err.full_response_data;
          //   this.sendResponse.emit(err);
          //   this.sendResponse.emit(err.full_response_data);
          //   this.test_message = err.full_response_data;
          //   console.log('FullRespoonse Error Inside Tools 3: ' + err.full_response_data)
          //   return(this.response_from_node = err);
      
      
      
                 // Need to set some error varibles
                 this.error_message = err.error.error_message;
                 this.error_message_standard = err.error.error_message_standard;
                 this.error_name = err.error.error_name;
                 this.full_response_data = err.error.full_response_data;
                 this.data_sent = err.error.data_sent;
                 this.data_sent_id = err.error.data_sent_invoice_id;
       
                
       
                 this.response_from_node = JSON.stringify(err)
                 this.response_from_node_raw = err;
                 this.sendResponse.emit(this.response_from_node);
                 console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
                 this.test_message = this.response_from_node; // could be as simple as this?
                 return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
      
      
            // return err.res.status(201).json({ success: " Supplier Agent RE-Connect Complete " });
          },

        // () =>  {
 
        // }
      );
       
        //   await this.delay(3000);
        //  })(); // end async function
  
        /// PUT DOUBLE FUNCTION ON BUTTON AS IT WAS NOT RUNNINT CORRCTly - now a process of three functions.
         // Loads first so that the rest of the subscription can run.
      // this.getInvoiceItmes(model.invoice_id);
  
  }
  
  
  getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  // this createds the myob invoice
  createMyobInvoiceModel(model, data_invoice){
    // if (confirm('We are about to Sync this Invoice with MYOB, Are you Sure?')) {
  // console.log('Invoice Data: ' + JSON.stringify(data_invoice));
  
  // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
  if (this.data_invoice!= '{}' ) {
      this._demoService.createMyobInvoice(this.data_invoice)
      .pipe(
        this.toastr.observe({
           loading: 'Updating...Pushing new data...Saving',
           success: '🚀',
           error: '😡 Creating the Invoice....'
        })
      )
      .subscribe(
      data => { this.myobInvoiceCreatedData = data;
        let res = data[0];
        let new_data_object = JSON.parse(this.myobInvoiceCreatedData);
  
  
        let location_string = new_data_object.location;
        // get everything after last dash 
        let slug = location_string.split('/').pop(); // 2020
        console.log('UUID slug: ' + slug);
  
                    // model.myob_id = slug;
                    // model.sync_with_myob = 1;
                    // this.updateSubjectInvoice(model);
                    // this.editBrand(model);
                    // this.refreshGrid();
                    // this.toastr.info('Invoice Upgraded In SOP');
  
        // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                  // need to pass the brand model here as its updatting the full SOP brand details.
                  this._demoService.getMyobInvoiceMapped(slug, model)
                //   .pipe(
                //     retry(0), // you retry 10 times
                //     delay(1500) // each retry will start after 1 second,
                //  )
                  .subscribe(
                     data4 => {
                      console.log(data4);
                      res = data4[0];
                    // many
                      // this.myobContactListMapped = data.data;
                    //single
                      this.myobInvoiceListMapped = data4;
                    // Set the returned Variables Reququied for Update of a Myob Customer.
                    console.log('UID: ' +  data4.UID);
                    console.log('LastModified: ' + data4.LastModified);
                    console.log('RowVersion: ' + data4.RowVersion);
                    // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                    // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
  
  
                    // work out the nulls for sub arraryas
                    let CategoryUID;
                    let OrderUID;
                    let SalespersonUID
  

                    // does this need to be data4. ????
                    if (typeof model.Category === 'undefined' || model.Category === null ) {
                      CategoryUID = null;
                    }else {
                      CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Order === 'undefined' || model.Order === null ) {
                      OrderUID = null;
                    }else {
                      OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                      SalespersonUID = null;
                    }else {
                      SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
  
  
                    this.set_RowVersion = data4.RowVersion;
                    // model.IsIndividual = data4.IsIndividual;
                    // model.SaleLayout = data4.SellingDetails.SaleLayout;
                    // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                    // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                    // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                    model.RowVersion = data4.RowVersion;
                    model.myob_array = JSON.stringify(data4);
                    model.myob_id = slug;
                    model.sync_with_myob = 1;
  
  
  // All Additional Myon Invoice Variables
     model.UID = data4.UID;
     model.Number = data4.Number;
     model.po_number = data4.po_number;
     model.Date = data4.Date;
     model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
     model.CustomerUID = data4.Customer.UID;
     model.CustomerName = data4.Customer.Name;
     model.CustomerDisplayID = data4.Customer.DisplayID;
     model.PromisedDate = data4.PromisedDate;
     model.BalanceDueAmount = data4.BalanceDueAmount;
     model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
     model.Status = data4.Status;
     model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
     model.TermsDiscountDate = data4.Terms.DiscountDate;
     model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
     model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
     model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
     model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
     model.TermsDiscount = data4.Terms.Discount;
     model.TermsDueDate = data4.Terms.DueDate;
     model.TermsFinanceCharge = data4.Terms.FinanceCharge;
     model.IsTaxInclusive = data4.IsTaxInclusive;
     model.Subtotal = data4.Subtotal;
     model.SubtotalForeign = data4.SubtotalForeign;
     model.Freight = data4.Freight;
     model.FreightForeign = data4.FreightForeign;
     model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
     model.TotalTax = data4.TotalTax;
     model.TotalTaxForeign = data4.TotalTaxForeign;
     model.TotalAmount = data4.TotalAmount;
     model.TotalAmountForeign = data4.TotalAmountForeign;
     model.CategoryUID = CategoryUID; // var
     model.SalespersonUID = SalespersonUID; // var
     model.Comment = data4.Comment;
     model.ShippingMethod = data4.ShippingMethod;
     model.JournalMemo = data4.JournalMemo;
     model.ReferralSource = data4.ReferralSource;
     model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
     model.LastPaymentDate = data4.LastPaymentDate;
     model.CanApplySurcharge = data4.CanApplySurcharge;
     model.OrderUID = OrderUID; // var
     model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
     model.ForeignCurrency = data4.ForeignCurrency;
     model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
     model.LastModified = data4.LastModified;
     model.URI = data4.URI;
     model.RowVersion = data4.RowVersion;
  
  
  
                    // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                    // UPDATE the invoice Items RowID, RowVersion and other details.
                        // HERE NOW
  
  
  
                              // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                              let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                              let  count_of_items = Object.keys(newArr).length;
                              //  let res = data[0];
                              // Run the job data queries.
                              // need to do a loop of subject_billing items (.length)
                              for(let i=0;i < count_of_items; i++) {
                                let res = newArr[i];
  
                              // empty array of invoiceItemsList first
                              this.invoiceItemsList = {};
  
                                let TaxCodeUID;
                                let JobUID;
                                let AccountUID;
                                let TaxCodeCode;
  
                              console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
                              // check for nulls on sub arrays
                              if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                              TaxCodeUID = null;
                              TaxCodeCode = null;
                              }else {
                              TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                              TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                              };
                              if (typeof res.Job === 'undefined' || res.Job === null ) {
                              JobUID = null;
                              }else {
                              JobUID = res.Job.UID; // can only call if actuall exist in the array!
                              };
                              if (typeof res.Account === 'undefined' || res.Account === null ) {
                              AccountUID = null;
                              }else {
                              AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                              };
  
                              this.invoiceItemsList = {
                              RowID: res.RowID,
                              Type: res.Type,
                              Description: res.Description,
                              UnitOfMeasure: res.UnitOfMeasure,
                              UnitCount: res.UnitCount,
                              UnitPrice: res.UnitPrice,
                              UnitPriceForeign: res.UnitPriceForeign,
                              DiscountPercent: res.DiscountPercent,
                              Total: res.Total,
                              TotalForeign: res.TotalForeign,
                              AccountUID: AccountUID, // var
                              JobUID: JobUID, // var
                              TaxCodeUID: TaxCodeUID, // var
                              TaxCodeCode: TaxCodeCode, // var
                              RowVersion: res.RowVersion
                                    };
  
                              console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                              // this.invoiceItemsList = this.invoiceItemsList;
                              if (this.invoiceItemsList !== '{}') {
                                // we udate each item in the loop that was just inserted.
                              this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
                              };
                              } // End Lines Loop
  
                    // Now run the actual invoice model update.
                    this.updateSubjectInvoice(model);  // updates the invoice
  
                    this.toastr.info('Invoice + Items Vrs Upgraded In SOP');
                    // this.refreshGrid();
                  },
                  (err) => {
                    // console.error('Error saving Event!');
                    
                    // // return the response to other components as well.
                    // this.toastr.error('Error Updating Invoice to Myob Details' + error.error_message_standard);
                    // this.response_from_node = error.full_response_data;
                    // // this.SendResponse.emit(error);
                    // // this.SendResponse.emit(error.full_response_data);
                    // console.log('FullRespoonse Error Inside Tools: ' + error.full_response_data)
                    // return(this.response_from_node = error);

                               // Need to set some error varibles
           this.error_message = err.error.error_message;
           this.error_message_standard = err.error.error_message_standard;
           this.error_name = err.error.error_name;
           this.full_response_data = err.error.full_response_data;
           this.data_sent = err.error.data_sent;
           this.data_sent_id = err.error.data_sent_invoice_id;
 
          
 
           this.response_from_node = JSON.stringify(err)
           this.response_from_node_raw = err;
           this.sendResponse.emit(this.response_from_node);
           console.log('FullRespoonse Error Inside Tools 6: ' + this.response_from_node)
           this.test_message = err.error.error_message_standard; // could be as simple as this?
          
           return(this.response_from_node = err); // do this so other componets get
           return(this.response_from_node = JSON.stringify(err)); // do this so other componets get

                     
                    console.log(err.error);
                   });
  
  
                  //  model.RowVersion = this.set_RowVersion;
  
  
                    
                      //  model.RowVersion = this.set_RowVersion;
                  //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
  
  
        // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
        // console.log('new_data date: ' + new_data_string.date);
        // console.log('new_data date: ' + new_data_string.location);
  
        // console.log(this.myobCustomerCreatedData.location);
        // // https://www.concretepage.com/questions/577
        //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        //  // console.log(this.arrCase);
        //  this.Items = data['Items'] ;
  
      
      },
      (err) => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
       console.log(err.error);


       this.toastr.error('Error Updating Invoice to Myob Details' + err.error.error_message_standard + '  <br> Details: ' + err.error.error_message);
      //  this.response_from_node = JSON.stringify(err);
      //  this.SendResponse.emit(error);
      //  this.SendResponse.emit(err);
  
      
       // Need to set some error varibles
          this.error_message = err.error.error_message;
          this.error_message_standard = err.error.error_message_standard;
          this.error_name = err.error.error_name;
          this.full_response_data = err.error.full_response_data;
          this.data_sent = err.error.data_sent;
          this.data_sent_id = err.error.data_sent_invoice_id;

         
          console.log('FullRespoonse Error Inside Tools 6: ' + this.response_from_node)

          this.response_from_node = JSON.stringify(err)
          this.response_from_node_raw = err;
          this.sendResponse.emit(this.response_from_node);
          console.log(' ' + this.response_from_node)
          this.test_message = this.response_from_node; // could be as simple as this?
          return(this.response_from_node = err); // do this so other componets get
          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get



      },
      // () => console.log('done loading Trace Types')
    );
  }// end if invoice_data
  
    // }; // end confirm
  
  };
  
  
  
  updateMyobInvoiceModelStep1(model){
    this.getUpdateInvoiceItmes(model.invoice_id, model);
      };
  
   // Get Invoice Items
  getUpdateInvoiceItmes(invoice_id, model){
    this._demoService.getSubjectInvoiceItems(invoice_id)
    .pipe(
    this.toastr.observe({
      loading: 'Connecting...Pushin data...Updating',
      success: '🚀',
      error: '😡'
   })
    )
    .subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  
  
  
    updateMyobInvoiceModelStep2(model){
     this._demoService.getBrandById(model.to_brand_id).subscribe(
       data => { this.brand = data;
       const  res = data[0];
                         this.brandData = res;
                   console.log('Brand MyobID: ' + res.myob_id);
                   console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                   console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                   // Invoice Model.- use return so that model is available in the outside subscription
                  
  // Memo if a subject or job invoice
  let JournalMemo: string;
  if (model.is_job_invoice >= 1) {
    JournalMemo = 'Job Invoice';
  }else{
    JournalMemo = 'Subject Invoice';
  };
  
  let BillDeliveryStatus: string;
  if (model.invoice_communication_status_id === 1) { // email
    BillDeliveryStatus = 'Nothing';
  }else{
    BillDeliveryStatus = 'Print';
  }
  
  // NEed tp add the extra update records and IDS in model
  
                   this.data_invoice = {
                  'UID': model.UID, // update fields for model 
                  'RowVersion': model.RowVersion, // update
  
                   'Number': model.invoice_number, //  model.invoice_number
                   'Date': model.date_created,
                   'SupplierInvoiceNumber': null,
                   'Customer': {
                   'UID': this.brandData.myob_id
                   },
                   'ShipToAddress': '' ,
                   'Terms': {
                   'PaymentIsDue': 'DayOfMonthAfterEOM',
                   'DiscountDate': 1,
                   'BalanceDueDate': 30,
                   'DiscountForEarlyPayment': 0,
                   'MonthlyChargeForLatePayment': 0,
                   'DiscountExpiryDate': model.due_date,
                   'Discount': 0,
                   'DueDate': model.due_date
                   },
                   'IsTaxInclusive': true,
                   'IsReportable': true,
  
                   'Lines': [
                   // {
                   // 'Type': '',
                   // 'Description': '' ,
                   // 'Account': {
                   // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                   // },
                   // 'Total': 6,
                   // 'Job': null,
                   // 'TaxCode': {
                   // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                   // }
                   // },
                   ],
  
                   'Subtotal': model.invoice_subtotal,
                   'Freight': 0,
                   'FreightTaxCode': {
                   'UID': this.gfunc.myob_FreightTaxCode
                   },
                   'TotalTax': model.invoice_gst,
                   'TotalAmount': model.invoice_total,
                   'Category': null,
                   'Comment': '',
                   'ShippingMethod': null,
                   'PromisedDate': null,
                   'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.invoice_number,
                   'BillDeliveryStatus': BillDeliveryStatus,
                   'AppliedToDate': 0,
                   'BalanceDueAmount': model.invoice_remaining_total,
                   'Status': 'Open',
                   'LastPaymentDate': null,
                   'Order': null,
                   'ForeignCurrency': null
                   };
  
  
  
                       // :: This function Collects and pushes the lines to the rows of the invoice.
                   // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                   // need to loop through the invoice model and create Lines.
  
                   let newArr = Object(this.invoice_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
  
                   let  count_of_items = Object.keys(newArr).length;
                   //  let res = data[0];
                   // Run the job data queries.
                   // need to do a loop of subject_billing items (.length)
                   for(let i=0;i < count_of_items; i++) {
                     let res2 = newArr[i];
  
  
                      // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!
                                    // this.getMyobTaxCodes(); // load this onInit.
                                    // this.getMyobAccountCodes();
                    const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc)=>(mtc.myob_tax_code_id === res2.myob_tax_code_id ));
                    const retAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === res2.myob_account_code_id ));
                    // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
                    // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));
  
                    
                    let TaxAccountUID = retTaxCodeUID[0].UID;
                    let MyobAccountUID = retAccountUID[0].UID;
  
                    console.log('Tax Code: ' + retTaxCodeUID[0].UID);
                    console.log('Acc Code: ' + retAccountUID[0].UID);
  
  
                    //  let new_line = {
                    //    'RowID': res.RowID, // requored update
                    //    'RowVersion': res.RowVersion, // required Update
                    //    'Type': 'Transaction',
                    //    'Description': res.billing_task_name,
                    //    'Account': {
                    //    'UID': MyobAccountUID,
                    //    },
                    //    'Total': res.total,
                    //    'Job': null,
                    //    'TaxCode': {
                    //    'UID': TaxAccountUID
                    //    }
                    //    };
  
                    this.new_line = null; // reset
  
                    // :: Determine to update row or insert new if Lines.RowID exista
  
                    if(res2.RowID != null) {
                    this.new_line = {
                      'RowID': res2.RowID, // requored update
                      'RowVersion': res2.RowVersion, // required Update
                      'Type': 'Transaction',
                      'Description': res2.billing_task_name,
                      'Account': {
                      'UID': MyobAccountUID,
                      },
                      'Total': res2.total,
                      'Job': null,
                      'TaxCode': {
                      'UID':  TaxAccountUID
                      }
                      };
                    }; // end update line
  
                    if (res2.RowID == null) {
                      this.new_line = {
                        // 'RowID': res2.RowID, // requored update
                        // 'RowVersion': res2.RowVersion, // required Update
                        'Type': 'Transaction',
                        'Description': res2.billing_task_name,
                        'Account': {
                        'UID': MyobAccountUID,
                        },
                        'Total': res2.total,
                        'Job': null,
                        'TaxCode': {
                        'UID':  TaxAccountUID
                        }
                        };
                      }; // end new line.
  
  
                   this.data_invoice.Lines.push(this.new_line);
                   }
  
                   console.log('Update Pushed Model: ' + JSON.stringify(this.data_invoice));
  
  
       },
       (err) => {
        //   this.sendResponse.emit(err);
        //  this.response_from_node = err;
        //   console.error(err);
        //   this.toastr.error('Error Updating Invoice to Myob Details' + err.error_message_standard);
        //   this.response_from_node = err.full_response_data;
        //   this.sendResponse.emit(err);
        //   this.sendResponse.emit(err.full_response_data);
        //   this.test_message = err.full_response_data;
        //   console.log('FullRespoonse Error Inside Tools 3: ' + err.full_response_data)
        //   return(this.response_from_node = err);
    
    
    
               // Need to set some error varibles
               this.error_message = err.error.error_message;
               this.error_message_standard = err.error.error_message_standard;
               this.error_name = err.error.error_name;
               this.full_response_data = err.error.full_response_data;
               this.data_sent = err.error.data_sent;
               this.data_sent_id = err.error.data_sent_invoice_id;
     
              
     
               this.response_from_node = JSON.stringify(err)
               this.response_from_node_raw = err;
               this.sendResponse.emit(this.response_from_node);
               console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
               this.test_message = this.response_from_node; // could be as simple as this?
               return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
    
    
          // return err.res.status(201).json({ success: " Supplier Agent RE-Connect Complete " });
        },
       () =>  {
         console.log('invoice model Loaded.');
       this.updateMyobInvoiceModel(model, this.data_invoice);
       }
     );
      
       //   await this.delay(3000);
       //  })(); // end async function
  
       /// PUT DOUBLE FUNCTION ON BUTTON AS IT WAS NOT RUNNINT CORRCTly - now a process of three functions.
        // Loads first so that the rest of the subscription can run.
     // this.getInvoiceItmes(model.invoice_id);
  
  }
  
  
  updateMyobInvoiceModel(model, data_invoice) {
    if (confirm('We are about to Sync and Update Invoice data to MYOB, Are you Sure?')) {
      // console.log('Invoice Data: ' + JSON.stringify(data_invoice));
      
      // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
      if (this.data_invoice!= '{}' ) {
          this._demoService.updateMyobInvoice(this.data_invoice)
          .pipe(
            retry(10), // you retry 3 times
            delay(1500) // each retry will start after 1 second,
         )
          .subscribe(
          data => { this.myobInvoiceUpdatedData = data;
            let res = data[0];
            let new_data_object = JSON.parse(this.myobInvoiceUpdatedData);
      
      
            let location_string = new_data_object.location;
            // get everything after last dash 
            let slug = location_string.split('/').pop(); // 2020
            console.log('UUID slug: ' + slug);
      
                        // model.myob_id = slug;
                        // model.sync_with_myob = 1;
                        // this.updateSubjectInvoice(model);
                        // this.editBrand(model);
                        // this.refreshGrid();
                        // this.toastr.info('Invoice Upgraded In SOP');
      
            // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                      // need to pass the brand model here as its updatting the full SOP brand details.
                      this._demoService.getMyobInvoiceMapped(slug, model).subscribe(
                         data4 => {
                          console.log(data4);
                          res = data4[0];
                        // many
                          // this.myobContactListMapped = data.data;
                        //single
                          this.myobInvoiceListMapped = data4;
                        // Set the returned Variables Reququied for Update of a Myob Customer.
                        console.log('UID: ' +  data4.UID);
                        console.log('LastModified: ' + data4.LastModified);
                        console.log('RowVersion: ' + data4.RowVersion);
                        // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                        // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
  
  
                    // work out the nulls for sub arraryas
                    let CategoryUID;
                    let OrderUID;
                    let SalespersonUID
  
                    if (typeof model.Category === 'undefined' || model.Category === null ) {
                      CategoryUID = null;
                    }else {
                      CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Order === 'undefined' || model.Order === null ) {
                      OrderUID = null;
                    }else {
                      OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
                    if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                      SalespersonUID = null;
                    }else {
                      SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                    };
  
  
  
  
  
                        this.set_RowVersion = data4.RowVersion;
                        // model.IsIndividual = data4.IsIndividual;
                        // model.SaleLayout = data4.SellingDetails.SaleLayout;
                        // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                        // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                        // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                        model.RowVersion = data4.RowVersion;
                        model.myob_array = JSON.stringify(data4);
                        model.myob_id = slug;
                        model.sync_with_myob = 1;
      
                        
  
  
  
  // All Additional Myon Invoice Variables
  model.UID = data4.UID;
  model.Number = data4.Number;
  model.Date = data4.Date;
  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
  model.CustomerUID = data4.Customer.UID;
  model.CustomerName = data4.Customer.Name;
  model.CustomerDisplayID = data4.Customer.DisplayID;
  model.PromisedDate = data4.PromisedDate;
  model.BalanceDueAmount = data4.BalanceDueAmount;
  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
  model.Status = data4.Status;
  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
  model.TermsDiscountDate = data4.Terms.DiscountDate;
  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
  model.TermsDiscount = data4.Terms.Discount;
  model.TermsDueDate = data4.Terms.DueDate;
  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
  model.IsTaxInclusive = data4.IsTaxInclusive;
  model.Subtotal = data4.Subtotal;
  model.SubtotalForeign = data4.SubtotalForeign;
  model.Freight = data4.Freight;
  model.FreightForeign = data4.FreightForeign;
  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
  model.TotalTax = data4.TotalTax;
  model.TotalTaxForeign = data4.TotalTaxForeign;
  model.TotalAmount = data4.TotalAmount;
  model.TotalAmountForeign = data4.TotalAmountForeign;
  model.CategoryUID = CategoryUID; // var
  model.SalespersonUID = SalespersonUID; // var
  model.Comment = data4.Comment;
  model.ShippingMethod = data4.ShippingMethod;
  model.JournalMemo = data4.JournalMemo;
  model.ReferralSource = data4.ReferralSource;
  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
  model.LastPaymentDate = data4.LastPaymentDate;
  model.CanApplySurcharge = data4.CanApplySurcharge;
  model.OrderUID = OrderUID; // var
  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
  model.ForeignCurrency = data4.ForeignCurrency;
  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
  model.LastModified = data4.LastModified;
  model.URI = data4.URI;
  model.RowVersion = data4.RowVersion;
  
  
  
                 // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                 // UPDATE the invoice Items RowID, RowVersion and other details.
                     // HERE NOW
  
  
  
                           // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                           let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                           let  count_of_items = Object.keys(newArr).length;
                           //  let res = data[0];
                           // Run the job data queries.
                           // need to do a loop of subject_billing items (.length)
                           for(let i=0;i < count_of_items; i++) {
                             let res = newArr[i];
  
                           // empty array of invoiceItemsList first
                           this.invoiceItemsList = {};
  
                             let TaxCodeUID;
                             let JobUID;
                             let AccountUID;
                             let TaxCodeCode;
  
                           console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
                           // check for nulls on sub arrays
                           if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                           TaxCodeUID = null;
                           TaxCodeCode = null;
                           }else {
                           TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                           TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                           };
                           if (typeof res.Job === 'undefined' || res.Job === null ) {
                           JobUID = null;
                           }else {
                           JobUID = res.Job.UID; // can only call if actuall exist in the array!
                           };
                           if (typeof res.Account === 'undefined' || res.Account === null ) {
                           AccountUID = null;
                           }else {
                           AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                           };
  
                           // so we can insert new items or remove ones that do not exist.
                           // NEW
                           this.invoiceItemsList = { 
                           RowID: res.RowID,
                           Type: res.Type,
                           Description: res.Description,
                           UnitOfMeasure: res.UnitOfMeasure,
                           UnitCount: res.UnitCount,
                           UnitPrice: res.UnitPrice,
                           UnitPriceForeign: res.UnitPriceForeign,
                           DiscountPercent: res.DiscountPercent,
                           Total: res.Total,
                           TotalForeign: res.TotalForeign,
                           AccountUID: AccountUID, // var
                           JobUID: JobUID, // var
                           TaxCodeUID: TaxCodeUID, // var
                           TaxCodeCode: TaxCodeCode, // var
                           RowVersion: res.RowVersion
                                 };
  
                           console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                           // this.invoiceItemsList = this.invoiceItemsList;
                           if (this.invoiceItemsList !== '{}') {
                             // we udate each item in the loop that was just inserted.
                           this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
                           };
                           } // End Lines Loop
  
  
  
  
  
                        this.updateSubjectInvoice(model);
                        this.toastr.info('Invoice Upgraded In Myob');
                        // this.refreshGrid();
                      },
                      error => {
                        // console.error('Error saving Event!');
                         this.toastr.error('Error Updating Invoice to Myob Details');
                        console.log(error.error);
                       });
      
      
                      //  model.RowVersion = this.set_RowVersion;
      
      
                        
                          //  model.RowVersion = this.set_RowVersion;
                      //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
      
      
            // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
            // console.log('new_data date: ' + new_data_string.date);
            // console.log('new_data date: ' + new_data_string.location);
      
            // console.log(this.myobCustomerCreatedData.location);
            // // https://www.concretepage.com/questions/577
            //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
            //  // console.log(this.arrCase);
            //  this.Items = data['Items'] ;
      
          
          },
          (err) => {
            //   this.sendResponse.emit(err);
            //  this.response_from_node = err;
            //   console.error(err);
            //   this.toastr.error('Error Updating Invoice to Myob Details' + err.error_message_standard);
            //   this.response_from_node = err.full_response_data;
            //   this.sendResponse.emit(err);
            //   this.sendResponse.emit(err.full_response_data);
            //   this.test_message = err.full_response_data;
            //   console.log('FullRespoonse Error Inside Tools 3: ' + err.full_response_data)
            //   return(this.response_from_node = err);
        
        
        
                   // Need to set some error varibles
                   this.error_message = err.error.error_message;
                   this.error_message_standard = err.error.error_message_standard;
                   this.error_name = err.error.error_name;
                   this.full_response_data = err.error.full_response_data;
                   this.data_sent = err.error.data_sent;
                   this.data_sent_id = err.error.data_sent_invoice_id;
         
                  
         
                   this.response_from_node = JSON.stringify(err)
                   this.response_from_node_raw = err;
                   this.sendResponse.emit(this.response_from_node);
                   console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
                   this.test_message = this.response_from_node; // could be as simple as this?
                   return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
        
        
              // return err.res.status(201).json({ success: " Supplier Agent RE-Connect Complete " });
            },
          // () => console.log('done loading Trace Types')
        );
      }// end if invoice_data
      
        }; // end confirm
      
  
  };
  
  
  
  
  
  public getMyobInvoices() {
    this._demoService.getMyobInvoices().subscribe(
      data => { this.myobInvoices = data;
        const res = data[0];
         // https://www.concretepage.com/questions/577
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.Items = data['Items'] ;
         console.log(this.Items);
        // this.Address = this.Items['Address'];
  // return this.myobCustomers;
  
  // Map the data top the new model system
  // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
  
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
        return JSON.stringify(err);
      },
      // () => console.log('done loading Trace Types')
    );
  
  }
  
  
  
  
  
  
  
  
  deleteMyobServiceInvoiceModel(model){
   // 7/02/24 Added to do a Myob Check First Prior to Making a move. // THIS WORKED LIKE A TREAT.
    this.myobChecker();
    if (confirm('This will delete this Invoice from Myob. We cannot undo this, Are you Sure?')) {
  this._demoService.deleteMyobInvoice(model)
  .pipe(
    this.toastr.observe({
      loading: 'Connecting...Pushing...Updating',
      success: '🚀',
      error: '😡 Deleting Invoice'
   })
   )
  .pipe(
    retry(3), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 )

  .subscribe(
      data => { this.myobInvoiceDeleteData = data;
        let res = data[0];
        model.myob_id = null;
        model.sync_with_myob = 0;
        this.updateSubjectInvoice(model);
          // this.refreshGrid();
        this.toastr.success('Invoice Deleted from with Myob');
      },
      err => {
        this.toastr.error('You will need to login and delete this invoice manually from myob, because you said no!');
       // console.error(err);


       this.toastr.error('Error Deleting Customer Invoice in MYOB' + err.error_message_standard);
       //  this.response_from_node = JSON.stringify(err);
       //  this.SendResponse.emit(error);
        this.sendResponse.emit(err);
        console.log('FullRespoonse : deleteMyobServiceInvoiceModel(model) ' + err.full_response_data)
       
        // Need to set some error varibles
           this.error_message = err.error.error_message;
           this.error_message_standard = err.error.error_message_standard;
           this.error_name = err.error.error_name;
           this.full_response_data = err.error.full_response_data;
           this.data_sent = err.error.data_sent;
           this.data_sent_id = err.error.data_sent_id;
 
           this.response_from_node_raw = err;
           return(this.response_from_node = JSON.stringify(err)); // do this so other componets get


       
      },
      // () => console.log('done loading Trace Types')
    );
  
    }; // end confirm
  
  };
  
  
  
  
  
  
  public getMyobInvoice(UID){
    this._demoService.getMyobInvoice(UID).subscribe(
      data => { this.myobInvoice = data;
        let res = data[0];
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.invoiceItem = data['Item'] ;
        // console.log(this.customerItem);
        // this.Address = this.Items['Address'];
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading')
    );
  }
  
  
  
  
  
  
  
  updateSubjectInvoice(invoice_model){
    this._demoService.updateSubjectInvoice(invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
    this.toastr.success('Local Invoice Updated-Refresh');


          // This is the true end of the process and I need to clear the two error arrays.
          // this.response_from_node = {};
          // this.response_from_node_raw = [];

          // // See if this refreshes the payment page after a payment is submitted to myob
          //   this.gfunc.globalJobSubjectBillingViewSkipRoute(invoice_model.subject_id);
          
          return true; // just to be safe

      },
      err => {
        console.log(err.error);


        this.sendResponse.emit(err);
        console.log('FullRespoonse : Error updating Local Invoice Data - updateSubjectInvoice(invoice_model ' + err.full_response_data)
       
        // Need to set some error varibles
           this.error_message = err.error.error_message;
           this.error_message_standard = err.error.error_message_standard;
           this.error_name = err.error.error_name;
           this.full_response_data = err.error.full_response_data;
           this.data_sent = err.error.data_sent;
           this.data_sent_id = err.error.data_sent_id;
 
           this.response_from_node_raw = err;
           return(this.response_from_node = JSON.stringify(err)); // do this so other componets get




        
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
  )
   }
  
  
  
  
   lookupInvoiceUpdateInvoice(UID, model) {
  
    this._demoService.getMyobInvoiceMapped(UID, model)
    .pipe(
      this.toastr.observe({
        loading: 'Connecting...Pushing...Updating - getMyobInvoiceMapped()',
        success: '🚀',
        error: '😡 Mapping Invoice - getMyobInvoiceMapped()'
     })
     )
    .pipe(
      retry(5), // you retry 3 times
      delay(1500) // each retry will start after 1 second,
   )
    .subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobInvoiceListMapped = data4;
     // Set the returned Variables Reququied for Update of a Myob Customer.
    //  console.log('UID: ' +  data4.UID);
    console.log('UID: ' +  data4.UID);
    console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
  
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof data4.Category === 'undefined' || data4.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof data4.Order === 'undefined' || data4.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof data4.Salesperson === 'undefined' || data4.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  
  
    this.set_RowVersion = data4.RowVersion;
    // Local data vars.
     model.myob_customer_array = JSON.stringify(data4);
     model.myob_id = data4.UID;
  
     model.UID = data4.UID;
     model.Number = data4.Number;
     model.Date = data4.Date;
     model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
     model.CustomerUID = data4.Customer.UID;
     model.CustomerName = data4.Customer.Name;
     model.CustomerDisplayID = data4.Customer.DisplayID;
     model.PromisedDate = data4.PromisedDate;
     model.BalanceDueAmount = data4.BalanceDueAmount;
     model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
     model.Status = data4.Status;
     model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
     model.TermsDiscountDate = data4.Terms.DiscountDate;
     model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
     model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
     model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
     model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
     model.TermsDiscount = data4.Terms.Discount;
     model.TermsDueDate = data4.Terms.DueDate;
     model.TermsFinanceCharge = data4.Terms.FinanceCharge;
     model.IsTaxInclusive = data4.IsTaxInclusive;
     model.Subtotal = data4.Subtotal;
     model.SubtotalForeign = data4.SubtotalForeign;
     model.Freight = data4.Freight;
     model.FreightForeign = data4.FreightForeign;
     model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
     model.TotalTax = data4.TotalTax;
     model.TotalTaxForeign = data4.TotalTaxForeign;
     model.TotalAmount = data4.TotalAmount;
     model.TotalAmountForeign = data4.TotalAmountForeign;
     model.CategoryUID = CategoryUID; // var
     model.SalespersonUID = SalespersonUID; // var
     model.Comment = data4.Comment;
     model.ShippingMethod = data4.ShippingMethod;
     model.JournalMemo = data4.JournalMemo;
     model.ReferralSource = data4.ReferralSource;
     model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
     model.LastPaymentDate = data4.LastPaymentDate;
     model.CanApplySurcharge = data4.CanApplySurcharge;
     model.OrderUID = OrderUID; // var
     model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
     model.ForeignCurrency = data4.ForeignCurrency;
     model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
     model.LastModified = data4.LastModified;
     model.URI = data4.URI;
     model.RowVersion = data4.RowVersion;
  
  
    //  this.updateSubjectInvoice(model);
     // update invoice itemes? to do Done BELOW... by description! to set row IDS
  
    // create a lines model with all new data and upate existing invoice_items.
  
  
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.invoiceItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
  this.invoiceItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };
    
    console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.invoiceItemsList !== '{}') {
    this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    };
    } // End Lines Loop
  
  
     this.toastr.info('Invoice Vrs Updated In SOP');
     // now finally update the invoice
     this.updateSubjectInvoice(model);
        // this.refreshGrid();
   },
   error => {
     // console.error('Error saving Event!');
      // this.toastr.error('Error Collecting Invoice Myob Details: getMyobInvoiceMapped() ');
     console.log(error.error);
    });
  }; // end loopup and update function
  
  
  
  
   // Get Invoice Items - Normal get
   getInvoiceItems(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        // this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  
  
  
    updateSubjectInvoiceItem(model, invoice_id){
      this._demoService.updateSubjectInvoiceItemByDescription(model, invoice_id).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route }); 
        // This worked and also works on invoice page as well.
       // this.gfunc.globalJobSubjectBillingView(model.subject_id); // turn off the redirect so it works on the myob-daily-tasks without refeshing
         return true;
        },
        err => {
          console.error(err);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
          return JSON.stringify(err)
        }
    )
     }


     updateSubjectInvoiceByUID(invoice_model){
      this._demoService.updateSubjectInvoiceByUID(invoice_model)
    //   .pipe(
    //     this.toastr.observe({
    //       loading: 'Updating Invoice By ID: updateSubjectInvoiceByUID()',
    //       success: '🚀',
    //       error: '😡 updateSubjectInvoiceByUID()'
    //    })
    //    )
    //   .pipe(
    //     retry(0), // you retry 3 times
    //     delay(1500) // each retry will start after 1 second,
    //  )
      .subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      this.toastr.success('Local Invoice Updated ...');
      return true;
      
          // See if this refreshes the payment page after a payment is submitted to myob
          if(invoice_model.subject_id){
          this.gfunc.globalJobSubjectBillingViewSkipRoute(invoice_model.subject_id);
          }

       
        },
        err => {

          // this sets the response_from_node varianle and function in scripts using this module
          // this.sendResponse.emit(error);
          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
          
          console.log(err.error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
    


  
     lookupInvoiceUpdateInvoice2(UID, model){
      this._demoService.getMyobInvoiceMapped(UID, model)
    //   .pipe(
    //     retry(3), // you retry 3 times
    //     delay(1200) // each retry will start after 1 second,
    //  )
      // .pipe(
      //   this.toastr.observe({
      //      loading: 'Connecting...Pushing data...Updating',
      //      success: '🚀',
      //      error: '😡'
      //   })
      // )
      .subscribe(
        data4 => {
         console.log(data4);
         let res = data4[0];
         this.myobInvoiceListMapped = data4;
       // Set the returned Variables Reququied for Update of a Myob Customer.
      //  console.log('UID: ' +  data4.UID);
      console.log('UID: ' +  data4.UID);
      // console.log('retInvoiceModel: ' +  JSON.stringify(data4));
    
   const sent_invoice_id = UID;
  //  const sent_real_invoice_id = model.invoice_id;
  
  
  this.invoice_model = {}; // clear the invoice moddl.
    
    // work out the nulls for sub arraryas
    let CategoryUID;
    let OrderUID;
    let SalespersonUID
    
    if (typeof data4.Category === 'undefined' || data4.Category === null ) {
      CategoryUID = null;
    }else {
      CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
    };
    if (typeof data4.Order === 'undefined' || data4.Order === null ) {
      OrderUID = null;
    }else {
      OrderUID = model.Category.UID; // can only call if actuall exist in the array!
    };
    if (typeof data4.Salesperson === 'undefined' || data4.Salesperson === null ) {
      SalespersonUID = null;
    }else {
      SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
    };
    
  
  
      this.set_RowVersion = data4.RowVersion;
      // Local data vars.
      //  model.myob_array = JSON.stringify(data4);
      //  model.myob_id = data4.UID;
    
      //  model.UID = data4.UID;
      //  model.Number = data4.Number;
      //  model.Date = data4.Date;
      //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
      //  model.CustomerUID = data4.Customer.UID;
      //  model.CustomerName = data4.Customer.Name;
      //  model.CustomerDisplayID = data4.Customer.DisplayID;
      //  model.PromisedDate = data4.PromisedDate;
      //  model.BalanceDueAmount = data4.BalanceDueAmount;
      //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
      //  model.Status = data4.Status;
      //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
      //  model.TermsDiscountDate = data4.Terms.DiscountDate;
      //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
      //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
      //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
      //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
      //  model.TermsDiscount = data4.Terms.Discount;
      //  model.TermsDueDate = data4.Terms.DueDate;
      //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
      //  model.IsTaxInclusive = data4.IsTaxInclusive;
      //  model.Subtotal = data4.Subtotal;
      //  model.SubtotalForeign = data4.SubtotalForeign;
      //  model.Freight = data4.Freight;
      //  model.FreightForeign = data4.FreightForeign;
      //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
      //  model.TotalTax = data4.TotalTax;
      //  model.TotalTaxForeign = data4.TotalTaxForeign;
      //  model.TotalAmount = data4.TotalAmount;
      //  model.TotalAmountForeign = data4.TotalAmountForeign;
      //  model.CategoryUID = CategoryUID; // var
      //  model.SalespersonUID = SalespersonUID; // var
      //  model.Comment = data4.Comment;
      //  model.ShippingMethod = data4.ShippingMethod;
      //  model.JournalMemo = data4.JournalMemo;
      //  model.ReferralSource = data4.ReferralSource;
      //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
      //  model.LastPaymentDate = data4.LastPaymentDate;
      //  model.CanApplySurcharge = data4.CanApplySurcharge;
      //  model.OrderUID = OrderUID; // var
      //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
      //  model.ForeignCurrency = data4.ForeignCurrency;
      //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
      //  model.LastModified = data4.LastModified;
      //  model.URI = data4.URI;
      //  model.RowVersion = data4.RowVersion;
    
  
       
  // make the function more universal? or make custom by itself?
       this.invoice_model = {
        myob_array: JSON.stringify(data4),
        myob_id: data4.UID,
        UID: data4.UID,
        Number: data4.Number,
        Date: data4.Date,
        CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
        CustomerUID: data4.Customer.UID,
        CustomerName: data4.Customer.Name,
        CustomerDisplayID: data4.Customer.DisplayID,
        PromisedDate: data4.PromisedDate,
        BalanceDueAmount: data4.BalanceDueAmount,
        BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
        Status: data4.Status,
        TermsPaymentIsDue: data4.Terms.PaymentIsDue,
        TermsDiscountDate: data4.Terms.DiscountDate,
        TermsBalanceDueDate: data4.Terms.BalanceDueDate,
        TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
        TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
        TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
        TermsDiscount: data4.Terms.Discount,
        TermsDueDate: data4.Terms.DueDate,
        TermsFinanceCharge: data4.Terms.FinanceCharge,
        IsTaxInclusive: data4.IsTaxInclusive,
        Subtotal: data4.Subtotal,
        SubtotalForeign: data4.SubtotalForeign,
        Freight: data4.Freight,
        FreightForeign: data4.FreightForeign,
        FreightTaxCodeUID: data4.FreightTaxCode.UID,
        TotalTax: data4.TotalTax,
        TotalTaxForeign: data4.TotalTaxForeign,
        TotalAmount: data4.TotalAmount,
        TotalAmountForeign: data4.TotalAmountForeign,
        CategoryUID: CategoryUID, // var
        SalespersonUID: SalespersonUID, // var
        Comment: data4.Comment,
        ShippingMethod: data4.ShippingMethod,
        JournalMemo: data4.JournalMemo,
        ReferralSource: data4.ReferralSource,
        InvoiceDeliveryStatus: data4.InvoiceDeliveryStatus,
        LastPaymentDate: data4.LastPaymentDate,
        CanApplySurcharge: data4.CanApplySurcharge,
        OrderUID: OrderUID, // var
        OnlinePaymentMethod: data4.OnlinePaymentMethod,
        ForeignCurrency: data4.ForeignCurrency,
        CurrencyExchangeRate: data4.CurrencyExchangeRate,
        LastModified: data4.LastModified,
        URI: data4.URI,
        RowVersion: data4.RowVersion,
        // invoice_id: data4.invoice_id // needed for update quiery.
        invoice_id: sent_invoice_id // set manuall and test.
              };
  
      //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
      //   // this.invoiceItemsList = this.invoiceItemsList;
      //   if (this.invoiceItemsList !== {}) {
      //     // we udate each item in the loop that was just inserted.
      //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
      //   };
  
  
  // this.invoice_model = this.invoice_model;
  // this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
  this.updateSubjectInvoiceByUID(this.invoice_model);
  
    // create a lines model with all new data and upate existing invoice_items
    // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
      let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
      let  count_of_items = Object.keys(newArr).length;
      //  let res = data[0];
      // Run the job data queries.
      // need to do a loop of subject_billing items (.length)
      for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
    
      // empty array of invoiceItemsList first
      this.invoiceItemsList = {};
    
        let TaxCodeUID;
        let JobUID;
        let AccountUID;
        let TaxCodeCode;
    
    // console.log('TaxCodeUID:' +  res.TaxCode.UID);
    
    // check for nulls on sub arrays
    if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
      TaxCodeUID = null;
      TaxCodeCode = null;
    }else {
      TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
      TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
    };
    if (typeof res.Job === 'undefined' || res.Job === null ) {
      JobUID = null;
    }else {
      JobUID = res.Job.UID; // can only call if actuall exist in the array!
    };
    if (typeof res.Account === 'undefined' || res.Account === null ) {
      AccountUID = null;
    }else {
      AccountUID = res.Account.UID; // can only call if actuall exist in the array!
    };
    
    this.invoiceItemsList = {
      RowID: res.RowID,
      Type: res.Type,
      Description: res.Description,
      UnitOfMeasure: res.UnitOfMeasure,
      UnitCount: res.UnitCount,
      UnitPrice: res.UnitPrice,
      UnitPriceForeign: res.UnitPriceForeign,
      DiscountPercent: res.DiscountPercent,
      Total: res.Total,
      TotalForeign: res.TotalForeign,
      AccountUID: AccountUID, // var
      JobUID: JobUID, // var
      TaxCodeUID: TaxCodeUID, // var
      TaxCodeCode: TaxCodeCode, // var
      RowVersion: res.RowVersion,
      // IMPORTANT !new 2023 as was loosing total etc after deleting payments and invoice updates.
          subject_id: this.subject_id,
          job_id: this.job_id,
          billing_task_name: res.billing_task_name,
          myob_tax_code_id: res.myob_tax_code_id,
          myob_account_code_id: res.myob_account_code_id,
          billing_task_description: res.billing_task_description,
          billing_task_fee: res.billing_task_fee,
          billing_task_id: res.billing_task_id,
          subject_number: this.subject_number,
          job_number: res.job_number,
          brand_id: res.brand_id,
          qty:res.qty,
          unit_price:res.unit_price,
          tax:res.tax,
          total:res.total
    };


            /*

    subject_id: this.subject_id,
    job_id: this.job_id,
    billing_task_name: this.billing_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_description: res.billing_task_description,
billing_task_fee: res.billing_task_fee,
billing_task_id: res.billing_task_id,
subject_number: this.subject_number,
job_number: this.job_number,
brand_id: this.brand_id,
qty:res.qty,
unit_price:res.unit_price,
tax:res.tax,
total:res.total
            */

           ///  I am loosing my billing items totals and couunts after removing the invoice, so I need to put these back... 
      
      // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
      // this.invoiceItemsList = this.invoiceItemsList;
      if (this.invoiceItemsList !== '{}') {
      this.updateSubjectInvoiceItem(this.invoiceItemsList, this.invoice_model.invoice_id);
      };
      } // End Lines Loop
    
    
       this.toastr.info('Invoice Vrs Updated In SOP');
       // now finally update the invoice
      //  this.updateSubjectInvoice(model);
          // this.refreshGrid();
     },
     err => {
       // console.error('Error saving Event!');
        // this.toastr.error('Error Collecting Invoice Myob Details');
       console.log(err.error);


          // // Need to set some error varibles
          // this.error_message = err.error.error_message;
          // this.error_message_standard = err.error.error_message_standard;
          // this.error_name = err.error.error_name;
          // this.full_response_data = err.error.full_response_data;
          // this.data_sent = err.error.data_sent;
          // this.data_sent_id = err.error.data_sent_invoice_id;

          this.response_from_node = JSON.stringify(err)
          this.response_from_node_raw = err;
          console.log('FullRespoonse Error createMyobWorkOrderModel(model, data_work_order): ' + this.response_from_node)
          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get



      });
    }; // end loopup and update function



    private getBrand(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          this.brand_data = data;
        },
        (err) => console.error(err),
        () => console.log('Brand Loaded.')
      );
    }
  



    myobChecker() {
      this._demoService.myobChecker().subscribe(
         data => { this.myob_checker = data;
          // let res = data[0];
          // this.toastr.success('Myob Connections Active!... functions allowed');
    // console.log('Connected: ', JSON.stringify(this.myob_checker));
    this.myob_response = true;
        },
         err => (
          // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
          this.myob_response = false,
          console.error(err)
         ),
         // () => console.log('done loading Trace Types')
       );
     }
    


/* End of Myob Functions */



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}




  
  }